import styled from '@emotion/styled';

import { Select as _Select } from '@hrworks/sui-core/Select';

const Select = styled(_Select)({
  '& [role="listbox"]': { color: 'initial' },
});

export const S = {
  Select,
} as const;
